import React, {useEffect, useState} from "react"
import styled from "styled-components"
import {Box} from "@mui/material"

import {api} from "@indebted/api"
import {useDebounce} from "@indebted/hooks"
import {theme} from "@indebted/theme"

function PreviewWithSegments({form}) {
	const debouncedForm = useDebounce(form)
	const [preview, setPreview] = useState(null)

	useEffect(() => {
		if (!debouncedForm.Locale) {
			setPreview(null)
			return
		}
		api.smsTemplate
			.previewWithSegments(debouncedForm)
			.then(setPreview)
			.catch(() => setPreview(null))
	}, [debouncedForm])

	if (!debouncedForm.Locale) {
		return <p>Select locale to start the preview</p>
	}

	if (!preview) {
		return <p>Loading preview...</p>
	}

	return <PreviewContent preview={preview} />
}

function PreviewContent({preview}) {
	const showWarning = preview.Encoding === "UCS-2"

	return (
		<>
			<EncodingInfo>
				<span>
					Encoding: {preview.Encoding} · Segments: {preview.Segments}
				</span>
				{showWarning && (
					<WarningText>
						This template contains non-GSM-7 characters, which increases the SMS segment count.
					</WarningText>
				)}
			</EncodingInfo>
			<PreviewIFrame srcDoc={preview.HTML} />
		</>
	)
}

const PreviewIFrame = styled.iframe`
	border: 0;
	width: 100%;
	height: 100%;
`

const EncodingInfo = styled(Box)`
	padding: ${theme.spacing(2)};
	font-size: 0.85rem;
	color: ${theme.palette.text.secondary};
`

const WarningText = styled.p`
	color: ${theme.palette.warning.main};
	margin-top: ${theme.spacing(1)};
	margin-bottom: 0;
`

export {PreviewWithSegments}
